import React from 'react';
import { useLang } from '../context/LanguageContext';
import { useContent } from '../context/ContentContext';

const About = () => {
  const { t, lang } = useLang();
  const { content } = useContent();

  const settings = content?.settings || {};
  const aboutKey = lang === 'fr' ? 'aboutFr' : 'aboutEn';
  const a = settings[aboutKey] || {};

  const title = a.title || t.about.title;
  const p1 = a.p1 || t.about.p1;
  const p2 = a.p2 || t.about.p2;

  const stats = [
    { v: '10+', l: t.about.stat1 },
    { v: '5K+', l: t.about.stat2 },
    { v: '4.2', l: t.about.stat3 },
    { v: '120+', l: t.about.stat4 },
  ];

  return (
    <section id="about" className="section-pad bg-[#FAF8F4]">
      <div className="container-tight grid lg:grid-cols-12 gap-16 items-center">
        <div className="lg:col-span-5 relative">
          <div className="aspect-[4/5] image-hover">
            <img
              src="https://images.pexels.com/photos/7005656/pexels-photo-7005656.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Studio"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-8 -right-4 bg-white border border-[#E8E2D5] p-6 hidden md:block max-w-[220px]">
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#957340] mb-2">Maison</div>
            <div className="serif text-[20px] leading-tight">17 Rue Louis Lenoir</div>
            <div className="text-[12px] text-[#8A8275] mt-1">94350 Villiers-sur-Marne</div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <span className="eyebrow left">{t.about.eyebrow}</span>
          <h2 className="h-display mt-6" style={{ fontSize: 'clamp(40px, 5vw, 64px)' }}>
            {title}
          </h2>
          <div className="gold-line my-8 w-32" />
          <p className="text-[16px] text-[#3A3A3A] leading-[1.85] mb-5">{p1}</p>
          <p className="text-[16px] text-[#3A3A3A] leading-[1.85]">{p2}</p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-14 border-t border-[#E8E2D5] pt-10">
            {stats.map((s) => (
              <div key={s.l}>
                <div className="display text-[44px] leading-none text-[#1A1A1A]">{s.v}</div>
                <div className="text-[10px] tracking-[0.28em] uppercase text-[#8A8275] mt-3">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
